const constants = ['UPDATE_USER_INFO', 'UPDATE_APP', 'SCREEN_DIMENSION_CHANGE'];

const DispatchConstants: any = constants.reduce((acc, value) => {
  acc[value] = value;
  return acc;
}, {});

export default DispatchConstants;
